import CashbackBonusImagesModal from './CashbackBonusImagesModal';
import CustomerEditModal from './CustomerEditModal';
import OfferImagesModal from './OfferImagesModal';
import PromoCodeImagesModal from './PromoCodeImagesModal';
import PromoCodeSettingModal from './PromoCodeSettingModal';
import RegenerationReasonModal from './RegenerationReasonModal';
import RequestDataDeletionModal from './RequestDataDeletionModal';
import SmartPricingRuleImagesModal from './SmartPricingRuleImagesModal';
import UploadPolygraphyProductModal from './UploadPolygraphyProductModal';

export default {
  CashbackBonusImagesModal,
  CustomerEditModal,
  OfferImagesModal,
  PromoCodeImagesModal,
  PromoCodeSettingModal,
  RegenerationReasonModal,
  RequestDataDeletionModal,
  SmartPricingRuleImagesModal,
  UploadPolygraphyProductModal,
};
